//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.16.1.0 (NJsonSchema v10.7.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

@Injectable()
export class ClientV3 {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : 'https://development.pulse.cloud/api/core';
  }

  /**
   * @return Success
   */
  countries_GetCountriesGET(): Observable<GetCountryListResponse> {
    let url_ = this.baseUrl + '/v3/countries';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCountries_GetCountriesGET(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCountries_GetCountriesGET(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<GetCountryListResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<GetCountryListResponse>;
        })
      );
  }

  protected processCountries_GetCountriesGET(response: HttpResponseBase): Observable<GetCountryListResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as GetCountryListResponse);
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result400: any = null;
          result400 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as PulseProblemDetails);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<GetCountryListResponse>(null as any);
  }

  /**
   * @param useCache (optional)
   * @param withSqlAnalytics (optional)
   * @param parentId (optional)
   * @param body (optional)
   * @return Success
   */
  filter_CreateDefaultValuesPOST(
    projectId: number,
    resourceId: number,
    useCache?: boolean | undefined,
    withSqlAnalytics?: boolean | undefined,
    parentId?: number | undefined,
    body?: CreateFilterRequest | undefined
  ): Observable<CreateDefaultFilterForResourceResponseV3> {
    let url_ = this.baseUrl + '/v3/projects/{projectId}/resources/{resourceId}/filters/create-default-values?';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (resourceId === undefined || resourceId === null) throw new Error("The parameter 'resourceId' must be defined.");
    url_ = url_.replace('{resourceId}', encodeURIComponent('' + resourceId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    if (withSqlAnalytics === null) throw new Error("The parameter 'withSqlAnalytics' cannot be null.");
    else if (withSqlAnalytics !== undefined)
      url_ += 'withSqlAnalytics=' + encodeURIComponent('' + withSqlAnalytics) + '&';
    if (parentId === null) throw new Error("The parameter 'parentId' cannot be null.");
    else if (parentId !== undefined) url_ += 'parentId=' + encodeURIComponent('' + parentId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processFilter_CreateDefaultValuesPOST(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processFilter_CreateDefaultValuesPOST(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<CreateDefaultFilterForResourceResponseV3>;
            }
          } else return _observableThrow(response_) as any as Observable<CreateDefaultFilterForResourceResponseV3>;
        })
      );
  }

  protected processFilter_CreateDefaultValuesPOST(
    response: HttpResponseBase
  ): Observable<CreateDefaultFilterForResourceResponseV3> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as CreateDefaultFilterForResourceResponseV3);
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result400: any = null;
          result400 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as UserErrorResponse);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<CreateDefaultFilterForResourceResponseV3>(null as any);
  }

  /**
   * @param useCache (optional)
   * @param withSqlAnalytics (optional)
   * @param parentId (optional)
   * @param body (optional)
   * @return Success
   */
  filter_CreateFilterPOST(
    projectId: number,
    resourceId: number,
    useCache?: boolean | undefined,
    withSqlAnalytics?: boolean | undefined,
    parentId?: number | undefined,
    body?: CreateFilterRequest | undefined
  ): Observable<FilterController_CreateFilterUiForResourceResponse> {
    let url_ = this.baseUrl + '/v3/projects/{projectId}/resources/{resourceId}/filters/create-filter?';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (resourceId === undefined || resourceId === null) throw new Error("The parameter 'resourceId' must be defined.");
    url_ = url_.replace('{resourceId}', encodeURIComponent('' + resourceId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    if (withSqlAnalytics === null) throw new Error("The parameter 'withSqlAnalytics' cannot be null.");
    else if (withSqlAnalytics !== undefined)
      url_ += 'withSqlAnalytics=' + encodeURIComponent('' + withSqlAnalytics) + '&';
    if (parentId === null) throw new Error("The parameter 'parentId' cannot be null.");
    else if (parentId !== undefined) url_ += 'parentId=' + encodeURIComponent('' + parentId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processFilter_CreateFilterPOST(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processFilter_CreateFilterPOST(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<FilterController_CreateFilterUiForResourceResponse>;
            }
          } else
            return _observableThrow(response_) as any as Observable<FilterController_CreateFilterUiForResourceResponse>;
        })
      );
  }

  protected processFilter_CreateFilterPOST(
    response: HttpResponseBase
  ): Observable<FilterController_CreateFilterUiForResourceResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(
                  _responseText,
                  this.jsonParseReviver
                ) as FilterController_CreateFilterUiForResourceResponse);
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result400: any = null;
          result400 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as UserErrorResponse);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<FilterController_CreateFilterUiForResourceResponse>(null as any);
  }

  /**
   * @param useCache (optional)
   * @return Success
   */
  projectConfiguration_AddProjectWithConfigurationIdPOST(
    configurationName: string,
    useCache?: boolean | undefined
  ): Observable<AddProjectWithConfigurationResponse> {
    let url_ = this.baseUrl + '/v3/project-configurations/{configurationName}/create-project?';
    if (configurationName === undefined || configurationName === null)
      throw new Error("The parameter 'configurationName' must be defined.");
    url_ = url_.replace('{configurationName}', encodeURIComponent('' + configurationName));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processProjectConfiguration_AddProjectWithConfigurationIdPOST(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processProjectConfiguration_AddProjectWithConfigurationIdPOST(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<AddProjectWithConfigurationResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<AddProjectWithConfigurationResponse>;
        })
      );
  }

  protected processProjectConfiguration_AddProjectWithConfigurationIdPOST(
    response: HttpResponseBase
  ): Observable<AddProjectWithConfigurationResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as AddProjectWithConfigurationResponse);
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result400: any = null;
          result400 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as UserErrorResponse);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result500: any = null;
          result500 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as PulseProblemDetails);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<AddProjectWithConfigurationResponse>(null as any);
  }

  /**
   * @param useCache (optional)
   * @param body (optional)
   * @return Success
   */
  projectConfiguration_AddProjectWithConfigurationPOST(
    useCache?: boolean | undefined,
    body?: AddProjectWithConfigurationPayload | undefined
  ): Observable<AddProjectWithConfigurationResponse> {
    let url_ = this.baseUrl + '/v3/project-configurations/create-project?';
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processProjectConfiguration_AddProjectWithConfigurationPOST(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processProjectConfiguration_AddProjectWithConfigurationPOST(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<AddProjectWithConfigurationResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<AddProjectWithConfigurationResponse>;
        })
      );
  }

  protected processProjectConfiguration_AddProjectWithConfigurationPOST(
    response: HttpResponseBase
  ): Observable<AddProjectWithConfigurationResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as AddProjectWithConfigurationResponse);
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result400: any = null;
          result400 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as UserErrorResponse);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result500: any = null;
          result500 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as PulseProblemDetails);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<AddProjectWithConfigurationResponse>(null as any);
  }

  /**
   * @param useCache (optional)
   * @return Success
   */
  project_GetProjectGET(projectId: number, useCache?: boolean | undefined): Observable<GetProjectResponse> {
    let url_ = this.baseUrl + '/v3/projects/{projectId}?';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processProject_GetProjectGET(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processProject_GetProjectGET(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<GetProjectResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<GetProjectResponse>;
        })
      );
  }

  protected processProject_GetProjectGET(response: HttpResponseBase): Observable<GetProjectResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as GetProjectResponse);
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result400: any = null;
          result400 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as UserErrorResponse);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result500: any = null;
          result500 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as PulseProblemDetails);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<GetProjectResponse>(null as any);
  }

  /**
   * @param useCache (optional)
   * @param body (optional)
   * @return Success
   */
  project_UpdateProjectPUT(
    projectId: number,
    useCache?: boolean | undefined,
    body?: UpdateProjectPayload | undefined
  ): Observable<UpdateProjectResponse> {
    let url_ = this.baseUrl + '/v3/projects/{projectId}?';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processProject_UpdateProjectPUT(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processProject_UpdateProjectPUT(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<UpdateProjectResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<UpdateProjectResponse>;
        })
      );
  }

  protected processProject_UpdateProjectPUT(response: HttpResponseBase): Observable<UpdateProjectResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as UpdateProjectResponse);
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result400: any = null;
          result400 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as UserErrorResponse);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result500: any = null;
          result500 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as PulseProblemDetails);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<UpdateProjectResponse>(null as any);
  }

  /**
   * @param useCache (optional)
   * @return No Content
   */
  project_DeleteProjectDELETE(projectId: number, useCache?: boolean | undefined): Observable<void> {
    let url_ = this.baseUrl + '/v3/projects/{projectId}?';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processProject_DeleteProjectDELETE(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processProject_DeleteProjectDELETE(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processProject_DeleteProjectDELETE(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result400: any = null;
          result400 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as UserErrorResponse);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result500: any = null;
          result500 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as PulseProblemDetails);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @param useCache (optional)
   * @return Success
   */
  project_GetProjectListGET(useCache?: boolean | undefined): Observable<GetProjectListResponse> {
    let url_ = this.baseUrl + '/v3/projects?';
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processProject_GetProjectListGET(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processProject_GetProjectListGET(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<GetProjectListResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<GetProjectListResponse>;
        })
      );
  }

  protected processProject_GetProjectListGET(response: HttpResponseBase): Observable<GetProjectListResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as GetProjectListResponse);
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result400: any = null;
          result400 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as UserErrorResponse);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result500: any = null;
          result500 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as PulseProblemDetails);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<GetProjectListResponse>(null as any);
  }

  /**
   * @param useCache (optional)
   * @param body (optional)
   * @return Success
   */
  project_AddProjectPOST(
    useCache?: boolean | undefined,
    body?: AddProjectPayload | undefined
  ): Observable<AddProjectResponse> {
    let url_ = this.baseUrl + '/v3/projects?';
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processProject_AddProjectPOST(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processProject_AddProjectPOST(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<AddProjectResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<AddProjectResponse>;
        })
      );
  }

  protected processProject_AddProjectPOST(response: HttpResponseBase): Observable<AddProjectResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as AddProjectResponse);
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result400: any = null;
          result400 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as UserErrorResponse);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result500: any = null;
          result500 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as PulseProblemDetails);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<AddProjectResponse>(null as any);
  }

  /**
   * @param useCache (optional)
   * @return Success
   */
  projectProperties_GetProjectPropertyGET(
    projectId: number,
    propertyId: string,
    useCache?: boolean | undefined
  ): Observable<GetProjectPropertyResponse> {
    let url_ = this.baseUrl + '/v3/projects/{projectId}/properties/{propertyId}?';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (propertyId === undefined || propertyId === null) throw new Error("The parameter 'propertyId' must be defined.");
    url_ = url_.replace('{propertyId}', encodeURIComponent('' + propertyId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processProjectProperties_GetProjectPropertyGET(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processProjectProperties_GetProjectPropertyGET(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<GetProjectPropertyResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<GetProjectPropertyResponse>;
        })
      );
  }

  protected processProjectProperties_GetProjectPropertyGET(
    response: HttpResponseBase
  ): Observable<GetProjectPropertyResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as GetProjectPropertyResponse);
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result400: any = null;
          result400 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as UserErrorResponse);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result500: any = null;
          result500 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as PulseProblemDetails);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<GetProjectPropertyResponse>(null as any);
  }

  /**
   * @param useCache (optional)
   * @return No Content
   */
  projectProperties_DeleteProjectPropertyDELETE(
    projectId: number,
    propertyId: number,
    useCache?: boolean | undefined
  ): Observable<void> {
    let url_ = this.baseUrl + '/v3/projects/{projectId}/properties/{propertyId}?';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (propertyId === undefined || propertyId === null) throw new Error("The parameter 'propertyId' must be defined.");
    url_ = url_.replace('{propertyId}', encodeURIComponent('' + propertyId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processProjectProperties_DeleteProjectPropertyDELETE(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processProjectProperties_DeleteProjectPropertyDELETE(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processProjectProperties_DeleteProjectPropertyDELETE(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result400: any = null;
          result400 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as UserErrorResponse);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result500: any = null;
          result500 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as PulseProblemDetails);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @param useCache (optional)
   * @return Success
   */
  projectProperties_GetProjectPropertyListGET(
    projectId: number,
    useCache?: boolean | undefined
  ): Observable<GetProjectPropertyListResponse> {
    let url_ = this.baseUrl + '/v3/projects/{projectId}/properties?';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processProjectProperties_GetProjectPropertyListGET(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processProjectProperties_GetProjectPropertyListGET(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<GetProjectPropertyListResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<GetProjectPropertyListResponse>;
        })
      );
  }

  protected processProjectProperties_GetProjectPropertyListGET(
    response: HttpResponseBase
  ): Observable<GetProjectPropertyListResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as GetProjectPropertyListResponse);
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result400: any = null;
          result400 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as UserErrorResponse);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result500: any = null;
          result500 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as PulseProblemDetails);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<GetProjectPropertyListResponse>(null as any);
  }

  /**
   * @param useCache (optional)
   * @param body (optional)
   * @return Success
   */
  projectProperties_UpdatePropertyProjectPUT(
    projectId: string,
    useCache?: boolean | undefined,
    body?: UpdateProjectPropertyPayload | undefined
  ): Observable<UpdateProjectPropertyResponse> {
    let url_ = this.baseUrl + '/v3/projects/{projectId}/properties?';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processProjectProperties_UpdatePropertyProjectPUT(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processProjectProperties_UpdatePropertyProjectPUT(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<UpdateProjectPropertyResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<UpdateProjectPropertyResponse>;
        })
      );
  }

  protected processProjectProperties_UpdatePropertyProjectPUT(
    response: HttpResponseBase
  ): Observable<UpdateProjectPropertyResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as UpdateProjectPropertyResponse);
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result400: any = null;
          result400 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as UserErrorResponse);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result500: any = null;
          result500 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as PulseProblemDetails);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<UpdateProjectPropertyResponse>(null as any);
  }

  /**
   * @param useCache (optional)
   * @param body (optional)
   * @return Success
   */
  projectProperties_AddProjectPropertyPOST(
    projectId: number,
    useCache?: boolean | undefined,
    body?: AddProjectPropertyPayload | undefined
  ): Observable<AddProjectPropertyResponse> {
    let url_ = this.baseUrl + '/v3/projects/{projectId}/properties?';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processProjectProperties_AddProjectPropertyPOST(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processProjectProperties_AddProjectPropertyPOST(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<AddProjectPropertyResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<AddProjectPropertyResponse>;
        })
      );
  }

  protected processProjectProperties_AddProjectPropertyPOST(
    response: HttpResponseBase
  ): Observable<AddProjectPropertyResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as AddProjectPropertyResponse);
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result400: any = null;
          result400 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as UserErrorResponse);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result500: any = null;
          result500 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as PulseProblemDetails);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<AddProjectPropertyResponse>(null as any);
  }

  /**
   * @param useCache (optional)
   * @return Success
   */
  providerConnection_GetProviderConnectionGET(
    providerConnectionId: number,
    useCache?: boolean | undefined
  ): Observable<GetProviderConnectionResponse> {
    let url_ = this.baseUrl + '/v3/provider-connections/{providerConnectionId}?';
    if (providerConnectionId === undefined || providerConnectionId === null)
      throw new Error("The parameter 'providerConnectionId' must be defined.");
    url_ = url_.replace('{providerConnectionId}', encodeURIComponent('' + providerConnectionId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processProviderConnection_GetProviderConnectionGET(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processProviderConnection_GetProviderConnectionGET(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<GetProviderConnectionResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<GetProviderConnectionResponse>;
        })
      );
  }

  protected processProviderConnection_GetProviderConnectionGET(
    response: HttpResponseBase
  ): Observable<GetProviderConnectionResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as GetProviderConnectionResponse);
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result400: any = null;
          result400 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as UserErrorResponse);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result500: any = null;
          result500 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as PulseProblemDetails);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<GetProviderConnectionResponse>(null as any);
  }

  /**
   * @param useCache (optional)
   * @param body (optional)
   * @return Success
   */
  providerConnection_UpdateProviderConnectionPUT(
    providerConnectionId: string,
    useCache?: boolean | undefined,
    body?: ProviderConnection2 | undefined
  ): Observable<UpdateProviderConnectionResponse> {
    let url_ = this.baseUrl + '/v3/provider-connections/{providerConnectionId}?';
    if (providerConnectionId === undefined || providerConnectionId === null)
      throw new Error("The parameter 'providerConnectionId' must be defined.");
    url_ = url_.replace('{providerConnectionId}', encodeURIComponent('' + providerConnectionId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processProviderConnection_UpdateProviderConnectionPUT(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processProviderConnection_UpdateProviderConnectionPUT(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<UpdateProviderConnectionResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<UpdateProviderConnectionResponse>;
        })
      );
  }

  protected processProviderConnection_UpdateProviderConnectionPUT(
    response: HttpResponseBase
  ): Observable<UpdateProviderConnectionResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as UpdateProviderConnectionResponse);
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result400: any = null;
          result400 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as UserErrorResponse);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result500: any = null;
          result500 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as PulseProblemDetails);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<UpdateProviderConnectionResponse>(null as any);
  }

  /**
   * @param useCache (optional)
   * @return No Content
   */
  providerConnection_DeleteProviderConnectionDELETE(
    providerConnectionId: number,
    useCache?: boolean | undefined
  ): Observable<void> {
    let url_ = this.baseUrl + '/v3/provider-connections/{providerConnectionId}?';
    if (providerConnectionId === undefined || providerConnectionId === null)
      throw new Error("The parameter 'providerConnectionId' must be defined.");
    url_ = url_.replace('{providerConnectionId}', encodeURIComponent('' + providerConnectionId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processProviderConnection_DeleteProviderConnectionDELETE(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processProviderConnection_DeleteProviderConnectionDELETE(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processProviderConnection_DeleteProviderConnectionDELETE(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result400: any = null;
          result400 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as UserErrorResponse);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result500: any = null;
          result500 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as PulseProblemDetails);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @param useCache (optional)
   * @return Success
   */
  providerConnection_GetProviderConnectionListGET(
    useCache?: boolean | undefined
  ): Observable<GetProviderConnectionListResponse> {
    let url_ = this.baseUrl + '/v3/provider-connections?';
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processProviderConnection_GetProviderConnectionListGET(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processProviderConnection_GetProviderConnectionListGET(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<GetProviderConnectionListResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<GetProviderConnectionListResponse>;
        })
      );
  }

  protected processProviderConnection_GetProviderConnectionListGET(
    response: HttpResponseBase
  ): Observable<GetProviderConnectionListResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as GetProviderConnectionListResponse);
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result400: any = null;
          result400 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as UserErrorResponse);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result500: any = null;
          result500 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as PulseProblemDetails);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<GetProviderConnectionListResponse>(null as any);
  }

  /**
   * @param useCache (optional)
   * @param body (optional)
   * @return Success
   */
  providerConnection_AddProviderConnectionPOST(
    useCache?: boolean | undefined,
    body?: AddProviderConnectionPayload | undefined
  ): Observable<AddProviderConnectionResponse> {
    let url_ = this.baseUrl + '/v3/provider-connections?';
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processProviderConnection_AddProviderConnectionPOST(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processProviderConnection_AddProviderConnectionPOST(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<AddProviderConnectionResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<AddProviderConnectionResponse>;
        })
      );
  }

  protected processProviderConnection_AddProviderConnectionPOST(
    response: HttpResponseBase
  ): Observable<AddProviderConnectionResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as AddProviderConnectionResponse);
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result400: any = null;
          result400 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as UserErrorResponse);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result500: any = null;
          result500 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as PulseProblemDetails);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<AddProviderConnectionResponse>(null as any);
  }

  /**
   * @param useCache (optional)
   * @param body (optional)
   * @return Success
   */
  resourceConfiguration_AddResourcesWithConfigurationsPOST(
    projectId: number,
    useCache?: boolean | undefined,
    body?: AddResourceListFromJsonPayload | undefined
  ): Observable<AddResourceListFromJsonResponse> {
    let url_ = this.baseUrl + '/v3/project/{projectId}/resource-configurations/create-resources?';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processResourceConfiguration_AddResourcesWithConfigurationsPOST(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processResourceConfiguration_AddResourcesWithConfigurationsPOST(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<AddResourceListFromJsonResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<AddResourceListFromJsonResponse>;
        })
      );
  }

  protected processResourceConfiguration_AddResourcesWithConfigurationsPOST(
    response: HttpResponseBase
  ): Observable<AddResourceListFromJsonResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as AddResourceListFromJsonResponse);
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result400: any = null;
          result400 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as UserErrorResponse);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result500: any = null;
          result500 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as PulseProblemDetails);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<AddResourceListFromJsonResponse>(null as any);
  }

  /**
   * @param useCache (optional)
   * @return Success
   */
  resourceTranslations_GetResourceTranslationListGET(
    projectId: number,
    resourceId: number,
    useCache?: boolean | undefined
  ): Observable<GetResourceTranslationListResponse> {
    let url_ = this.baseUrl + '/v3/projects/{projectId}/resources/{resourceId}/translations?';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (resourceId === undefined || resourceId === null) throw new Error("The parameter 'resourceId' must be defined.");
    url_ = url_.replace('{resourceId}', encodeURIComponent('' + resourceId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processResourceTranslations_GetResourceTranslationListGET(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processResourceTranslations_GetResourceTranslationListGET(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<GetResourceTranslationListResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<GetResourceTranslationListResponse>;
        })
      );
  }

  protected processResourceTranslations_GetResourceTranslationListGET(
    response: HttpResponseBase
  ): Observable<GetResourceTranslationListResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as GetResourceTranslationListResponse);
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result400: any = null;
          result400 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as UserErrorResponse);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result500: any = null;
          result500 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as PulseProblemDetails);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<GetResourceTranslationListResponse>(null as any);
  }

  /**
   * @param useCache (optional)
   * @return No Content
   */
  resourceTranslations_DeleteResourceTranslationsDELETE(
    projectId: number,
    resourceId: number,
    useCache?: boolean | undefined
  ): Observable<void> {
    let url_ = this.baseUrl + '/v3/projects/{projectId}/resources/{resourceId}/translations?';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (resourceId === undefined || resourceId === null) throw new Error("The parameter 'resourceId' must be defined.");
    url_ = url_.replace('{resourceId}', encodeURIComponent('' + resourceId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processResourceTranslations_DeleteResourceTranslationsDELETE(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processResourceTranslations_DeleteResourceTranslationsDELETE(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processResourceTranslations_DeleteResourceTranslationsDELETE(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result400: any = null;
          result400 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as UserErrorResponse);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result500: any = null;
          result500 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as PulseProblemDetails);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  user_AddUserPOST(body?: AddUserPayload | undefined): Observable<AddUserResponse> {
    let url_ = this.baseUrl + '/v3/users';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUser_AddUserPOST(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUser_AddUserPOST(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<AddUserResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<AddUserResponse>;
        })
      );
  }

  protected processUser_AddUserPOST(response: HttpResponseBase): Observable<AddUserResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as AddUserResponse);
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result400: any = null;
          result400 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as UserErrorResponse);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result500: any = null;
          result500 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as PulseProblemDetails);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<AddUserResponse>(null as any);
  }

  /**
   * @param page (optional)
   * @param pageSize (optional)
   * @param sortOrderColumn (optional)
   * @param sortOderAscending (optional)
   * @param searchString (optional)
   * @param useCache (optional)
   * @return Success
   */
  user_GetUserListGET(
    page?: number | undefined,
    pageSize?: number | undefined,
    sortOrderColumn?: UserSortColumns | undefined,
    sortOderAscending?: boolean | undefined,
    searchString?: string | undefined,
    useCache?: boolean | undefined
  ): Observable<GetUserListResponse> {
    let url_ = this.baseUrl + '/v3/users?';
    if (page === null) throw new Error("The parameter 'page' cannot be null.");
    else if (page !== undefined) url_ += 'page=' + encodeURIComponent('' + page) + '&';
    if (pageSize === null) throw new Error("The parameter 'pageSize' cannot be null.");
    else if (pageSize !== undefined) url_ += 'pageSize=' + encodeURIComponent('' + pageSize) + '&';
    if (sortOrderColumn === null) throw new Error("The parameter 'sortOrderColumn' cannot be null.");
    else if (sortOrderColumn !== undefined) url_ += 'sortOrderColumn=' + encodeURIComponent('' + sortOrderColumn) + '&';
    if (sortOderAscending === null) throw new Error("The parameter 'sortOderAscending' cannot be null.");
    else if (sortOderAscending !== undefined)
      url_ += 'sortOderAscending=' + encodeURIComponent('' + sortOderAscending) + '&';
    if (searchString === null) throw new Error("The parameter 'searchString' cannot be null.");
    else if (searchString !== undefined) url_ += 'searchString=' + encodeURIComponent('' + searchString) + '&';
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUser_GetUserListGET(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUser_GetUserListGET(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<GetUserListResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<GetUserListResponse>;
        })
      );
  }

  protected processUser_GetUserListGET(response: HttpResponseBase): Observable<GetUserListResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as GetUserListResponse);
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result400: any = null;
          result400 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as UserErrorResponse);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result500: any = null;
          result500 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as PulseProblemDetails);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<GetUserListResponse>(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  user_UpdateUserPUT(body?: UpdateUserPayload | undefined): Observable<UpdateUserResponse> {
    let url_ = this.baseUrl + '/v3/users';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUser_UpdateUserPUT(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUser_UpdateUserPUT(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<UpdateUserResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<UpdateUserResponse>;
        })
      );
  }

  protected processUser_UpdateUserPUT(response: HttpResponseBase): Observable<UpdateUserResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as UpdateUserResponse);
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result400: any = null;
          result400 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as UserErrorResponse);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result500: any = null;
          result500 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as PulseProblemDetails);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<UpdateUserResponse>(null as any);
  }

  /**
   * @param useCache (optional)
   * @return Success
   */
  user_GetUserGET(externalId: string, useCache?: boolean | undefined): Observable<GetUserResponse> {
    let url_ = this.baseUrl + '/v3/users/{externalId}?';
    if (externalId === undefined || externalId === null) throw new Error("The parameter 'externalId' must be defined.");
    url_ = url_.replace('{externalId}', encodeURIComponent('' + externalId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUser_GetUserGET(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUser_GetUserGET(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<GetUserResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<GetUserResponse>;
        })
      );
  }

  protected processUser_GetUserGET(response: HttpResponseBase): Observable<GetUserResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as GetUserResponse);
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result400: any = null;
          result400 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as UserErrorResponse);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result500: any = null;
          result500 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as PulseProblemDetails);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<GetUserResponse>(null as any);
  }

  /**
   * @return No Content
   */
  user_DeleteUserDELETE(userId: number): Observable<void> {
    let url_ = this.baseUrl + '/v3/users/{userId}';
    if (userId === undefined || userId === null) throw new Error("The parameter 'userId' must be defined.");
    url_ = url_.replace('{userId}', encodeURIComponent('' + userId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUser_DeleteUserDELETE(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUser_DeleteUserDELETE(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processUser_DeleteUserDELETE(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result400: any = null;
          result400 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as UserErrorResponse);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result500: any = null;
          result500 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as PulseProblemDetails);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * Grant actions on resources for user to its internal role, Auth: AdminPrivilege
   * @param useCache (optional)
   * @param body (optional)
   * @return Success
   */
  userAccess_AddResourceAccessListPOST(
    projectId: number,
    useCache?: boolean | undefined,
    body?: AddUserResourceAccessListPayload | undefined
  ): Observable<AddUserResourceAccessListResponse> {
    let url_ = this.baseUrl + '/v3/project/{projectId}/user/resourceaccess-list?';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUserAccess_AddResourceAccessListPOST(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUserAccess_AddResourceAccessListPOST(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<AddUserResourceAccessListResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<AddUserResourceAccessListResponse>;
        })
      );
  }

  protected processUserAccess_AddResourceAccessListPOST(
    response: HttpResponseBase
  ): Observable<AddUserResourceAccessListResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as AddUserResourceAccessListResponse);
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result400: any = null;
          result400 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as UserErrorResponse);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result500: any = null;
          result500 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as PulseProblemDetails);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<AddUserResourceAccessListResponse>(null as any);
  }

  /**
   * Grant actions on resources for user to its internal role, Auth: AdminPrivilege
   * @return No Content
   */
  userId_UpdateKeyCloakUserIdGET(): Observable<void> {
    let url_ = this.baseUrl + '/v3/users/update-keycloak-userid';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUserId_UpdateKeyCloakUserIdGET(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUserId_UpdateKeyCloakUserIdGET(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processUserId_UpdateKeyCloakUserIdGET(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result400: any = null;
          result400 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as UserErrorResponse);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result500: any = null;
          result500 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as PulseProblemDetails);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<void>(null as any);
  }
}

export interface ProblemDetails {
  type: string | undefined;
  title: string | undefined;
  status: number | undefined;
  detail: string | undefined;
  instance: string | undefined;
}

export interface ProblemDetailsException {
  targetSite: MethodBase;
  readonly message: string;
  readonly data: { [key: string]: any };
  innerException: Exception;
  helpLink: string | undefined;
  source: string | undefined;
  hResult: number;
  readonly stackTrace: string | undefined;
  problemDetails: PulseProblemDetails;
}

export interface PulseProblemDetails {
  responseType: string | undefined;
  title: string | undefined;
  details: string | undefined;
  statusCode: number;
  errorDetails: { [key: string]: any } | undefined;
}

export interface UserErrorResponse {
  responseType: string | undefined;
  statusCode: number;
  title: string | undefined;
  details: string | undefined;
  errors: string[] | undefined;
}

export interface CacheInfo {
  objectFromCache: boolean;
  cacheKey: string | undefined;
}

export interface AccessPolicyItem {
  accessPolicyId: number;
  resourceFlagProjectPage: boolean | undefined;
  projectId: number;
  projectName: string | undefined;
  projectShortName: string | undefined;
  actionId: number;
  actionName: string | undefined;
  resourceId: number;
  resourceName: string | undefined;
  resourceDescription: string | undefined;
  resourceTypeId: number;
  resourceTypeName: string | undefined;
  resourceImageLink: string | undefined;
  resourceSortOrder: number | undefined;
  roleId: number;
  roleIsInternal: boolean | undefined;
}

export interface ActionDTO {
  id: number;
  name: string | undefined;
  resourceTypeId: number;
}

export interface AddUserToProjectResponse {
  success: boolean;
}

export interface AdminPrivilege {
  id: number;
  name: string | undefined;
  description: string | undefined;
  lastUpdatedByUserId: number;
}

export interface Category {
  id: number;
  parentId: number;
  projectId: number;
  name: string | undefined;
  descriptionShort: string | undefined;
  descriptionLong: string | undefined;
  imageLink: string | undefined;
  sortOrder: number;
}

export interface CreateDefaultFilterForResourceResponseV3 {
  cacheInfo: CacheInfo;
  defaultFilterList: FilterUi[] | undefined;
}

export interface CreateFilterRequest {
  filterValues: FilterUiSelection[] | undefined;
  excludedFilterGroupCacheKeys: string[] | undefined;
}

export interface PageInfo_1OfRoleDTO {
  currentPage: number;
  pageSize: number;
  items: RoleDTO[] | undefined;
  totalItems: number;
}

export interface PageInfo_1OfUserBase {
  currentPage: number;
  pageSize: number;
  items: UserBase[] | undefined;
  totalItems: number;
}

export interface FilterCategoryDTO {
  id: number;
  label: string | undefined;
  icon: string | undefined;
  order: number;
}

export interface FilterDTO {
  id: number;
  label: string | undefined;
  icon: string | undefined;
  filterType: string | undefined;
  filterCategoryId: number;
  filterGroupId: number;
  providerConnectionId: number;
  tablename: string | undefined;
  columns: Resource[] | undefined;
  order: number;
  hasAll: boolean | undefined;
  token: FilterTokenDTO[] | undefined;
  values: FilterValueDTO[] | undefined;
  valueRange: FilterValueRangeDTO;
  toolTip: string | undefined;
}

export interface FilterGroupDTO {
  id: number;
  name: string | undefined;
  sortOrder: number;
  showOnHeader: boolean;
  visibility: string | undefined;
  icon: string | undefined;
  toolTip: string | undefined;
  interdependentFilterGroups: number[] | undefined;
  filters: FilterDTO[] | undefined;
  categories: FilterCategoryDTO[] | undefined;
}

export interface FilterTokenDTO {
  label: string | undefined;
  selection: FilterValueDTO[] | undefined;
}

export interface FilterValueDTO {
  value: string | undefined;
  label: string | undefined;
  column: string | undefined;
  isSelected: boolean;
  isDisabled: boolean;
  children: FilterValueDTO[] | undefined;
}

export interface FilterValueRangeDTO {
  min: string | undefined;
  max: string | undefined;
  column: string | undefined;
}

export interface GetAllRolesResponse {
  cacheInfo: CacheInfo;
  roles: PageInfo_1OfRoleDTO;
}

export interface GetIsGlobalAdminResponse {
  cacheInfo: CacheInfo;
  isGlobalAdmin: boolean;
}

export interface GetRoleResponse {
  cacheInfo: CacheInfo;
  roleDto: RoleDTO;
}

export interface GetUserFromProjectResponse {
  cacheInfo: CacheInfo;
  user: UserBase;
}

export interface GetUserFullResponse {
  cacheInfo: CacheInfo;
  userFull: UserFull;
}

export interface GetUsersResponse {
  cacheInfo: CacheInfo;
  users: PageInfo_1OfUserBase;
}

export interface EMailAddress {
  mail: string | undefined;
  displayName: string | undefined;
}

export interface MailConfiguration {
  subject: string | undefined;
  body: string | undefined;
  isEncrypted: boolean;
  isSigned: boolean;
  isBodyHtml: boolean;
  attachments: string | undefined;
  displayName: string | undefined;
  replyTo: string | undefined;
}

export interface MailList {
  recipients: EMailAddress[] | undefined;
  copyReciepients: EMailAddress[] | undefined;
  blindCopyRecipients: EMailAddress[] | undefined;
  tag: string | undefined;
  customId: string | undefined;
  customIdType: string | undefined;
}

export interface MailSendRequest {
  projectId: number;
  mailConfiguration: MailConfiguration;
  mailList: MailList[] | undefined;
  contactData: any[] | undefined;
}

export interface MailSendResponse {
  success: boolean;
}

export interface ManagementInitDTO {
  users: UserBase[] | undefined;
  adminPrivileges: AdminPrivilege[] | undefined;
  resources: ResourceDTO[] | undefined;
  roles: RoleDTO[] | undefined;
  resourceTypes: ResourceTypeAccess[] | undefined;
}

export interface PermissionValueDTO {
  permissionSet: string | undefined;
  databaseColumn: string | undefined;
  databaseValue: string | undefined;
  rowLevelSecurityId: number;
  columnGroupId: number;
  columnDefinitionId: number;
}

export interface Project {
  id: number;
  name: string | undefined;
  description: string | undefined;
  shortName: string | undefined;
  isPublic: boolean;
  properties: { [key: string]: string } | undefined;
}

export interface ProjectBase {
  id: number;
  name: string | undefined;
  description: string | undefined;
  shortName: string | undefined;
  isPublic: boolean;
}

export interface ProjectDetail {
  projectId: number;
  projectName: string | undefined;
  projectShortName: string | undefined;
  properties: { [key: string]: string } | undefined;
}

export interface ProjectInitDTO {
  user: User;
  adminPrivilege: number[] | undefined;
  resources: ResourceDTO[] | undefined;
  resourceTypes: ResourceTypeAction[] | undefined;
  categories: Category[] | undefined;
  project: Project;
  tenantSettings: TenantSetting[] | undefined;
  isGlobalAdmin: boolean;
}

export interface ProjectPropertyDTO {
  id: number;
  projectId: number;
  name: string | undefined;
  value: string | undefined;
}

export interface ProviderConnection {
  id: number;
  providerType: string | undefined;
  sqlType: string | undefined;
  name: string | undefined;
  databaseName: string | undefined;
  server: string | undefined;
  proxy: string | undefined;
  awsSecret: string | undefined;
}

export interface ProviderConnectionDTO {
  id: number;
  name: string | undefined;
  resourceTypeId: number;
}

export interface Resource {
  id: number;
  name: string | undefined;
  description: string | undefined;
  imageLink: string | undefined;
  category: string | undefined;
  categoryId: number | undefined;
  subCategory: string | undefined;
  subCategoryId: number | undefined;
  resourceTypeId: number;
  flagProjectPage: boolean;
  projectId: number;
  sortOrder: number;
  createdOn: Date | undefined;
  createdByUserId: number;
  createdByUser: string | undefined;
  lastUpdatedOn: Date | undefined;
  lastUpdatedByUserId: number;
  lastUpdatedByUser: string | undefined;
  properties: { [key: string]: string } | undefined;
  fromCache: boolean;
}

export interface ResourceAccess {
  resourceId: number;
  actions: number[] | undefined;
  roleId: number;
  roleName: string | undefined;
  isInternal: boolean;
  isGeneralAccess: boolean;
}

export interface ResourceAccessRequest {
  resourceId: number;
  actions: number[] | undefined;
}

export interface ResourceBase {
  id: number;
  name: string | undefined;
  description: string | undefined;
  imageLink: string | undefined;
  category: string | undefined;
  categoryId: number | undefined;
  subCategory: string | undefined;
  subCategoryId: number | undefined;
  resourceTypeId: number;
  flagProjectPage: boolean;
  projectId: number;
  sortOrder: number;
  createdOn: Date | undefined;
  createdByUserId: number;
  createdByUser: string | undefined;
  lastUpdatedOn: Date | undefined;
  lastUpdatedByUserId: number;
  lastUpdatedByUser: string | undefined;
}

export interface ResourceDTO {
  id: number;
  name: string | undefined;
  description: string | undefined;
  imageLink: string | undefined;
  category: string | undefined;
  categoryId: number | undefined;
  subCategory: string | undefined;
  subCategoryId: number | undefined;
  resourceTypeId: number;
  flagProjectPage: boolean;
  projectId: number;
  sortOrder: number;
  createdOn: Date | undefined;
  createdByUserId: number;
  createdByUser: string | undefined;
  lastUpdatedOn: Date | undefined;
  lastUpdatedByUserId: number;
  lastUpdatedByUser: string | undefined;
  properties: { [key: string]: string } | undefined;
  fromCache: boolean;
  actions: string[] | undefined;
  childResourceIds: number[] | undefined;
  parentResourceIds: number[] | undefined;
}

export interface ResourceFull {
  id: number;
  name: string | undefined;
  description: string | undefined;
  imageLink: string | undefined;
  category: string | undefined;
  categoryId: number | undefined;
  subCategory: string | undefined;
  subCategoryId: number | undefined;
  resourceTypeId: number;
  flagProjectPage: boolean;
  projectId: number;
  sortOrder: number;
  createdOn: Date | undefined;
  createdByUserId: number;
  createdByUser: string | undefined;
  lastUpdatedOn: Date | undefined;
  lastUpdatedByUserId: number;
  lastUpdatedByUser: string | undefined;
  properties: { [key: string]: string } | undefined;
  fromCache: boolean;
  actions: string[] | undefined;
  childResourceIds: number[] | undefined;
  parentResourceIds: number[] | undefined;
  resourceToResourceProperties: { [key: string]: string } | undefined;
  childResources: ResourceFull[] | undefined;
}

export interface ResourceType {
  id: number;
  name: string | undefined;
  isInternal: boolean;
  isTopLevelResource: boolean;
}

export interface ResourceTypeAccess {
  id: number;
  name: string | undefined;
  isInternal: boolean;
  isTopLevelResource: boolean;
  actions: ActionDTO[] | undefined;
}

export interface ResourceTypeAccessGeneral {
  resourceTypeId: number;
  roleId: number;
  roleName: string | undefined;
  actions: number[] | undefined;
  categories: number[] | undefined;
}

export interface ResourceTypeAction {
  id: number;
  name: string | undefined;
  isInternal: boolean;
  isTopLevelResource: boolean;
  actions: string[] | undefined;
  categoryIds: number[] | undefined;
}

export interface ResourceTypeDefinition {
  id: number;
  resourceTypeId: number;
  propertyName: string | undefined;
  propertyTranslationKey: string | undefined;
  propertyType: string | undefined;
  defaultValue: string | undefined;
  valueList: string | undefined;
  visualizationType: string | undefined;
  relationalPropertyResourceTypeId: number;
  isMandatory: boolean;
  isSubResourceEagerlyLoaded: boolean;
  sortOrder: number;
}

export interface RoleAccess {
  roleId: number;
  resourceAccess: ResourceAccess[] | undefined;
}

export enum RoleColumnEnum {
  Id = 'Id',
  Name = 'Name',
  Description = 'Description',
}

export interface RoleDTO {
  id: number;
  name: string | undefined;
  description: string | undefined;
  projectId: number;
  isInternal: boolean | undefined;
}

export interface RoleFull {
  roleInfo: RoleDTO;
  resourceTypeAccess: ResourceTypeAccessGeneral[] | undefined;
  resourceAccess: ResourceAccess[] | undefined;
  userAttachedToThisRole: number[] | undefined;
}

export interface SearchUsersResponse {
  users: UserBase[] | undefined;
}

export interface Measure {
  value: number;
  unit: string | undefined;
}

export interface SqlAnalyticResult {
  class: string | undefined;
  method: string | undefined;
  sqlExecutionTime: Measure;
  sql: string | undefined;
  info: string | undefined;
}

export interface SqlAnalyticResults {
  totalMeasure: Measure;
  results: SqlAnalyticResult[] | undefined;
}

export interface TenantSetting {
  setting: string | undefined;
  value: string | undefined;
}

export interface User {
  id: number;
  externalId: string | undefined;
  firstName: string | undefined;
  lastName: string | undefined;
  email: string | undefined;
  orgCode: string | undefined;
  isActive: boolean | undefined;
  isApiUser: boolean | undefined;
  properties: { [key: string]: string } | undefined;
}

export interface UserBase {
  id: number;
  externalId: string | undefined;
  firstName: string | undefined;
  lastName: string | undefined;
  email: string | undefined;
  orgCode: string | undefined;
  isActive: boolean | undefined;
  isApiUser: boolean | undefined;
}

export interface UserFull {
  userBase: UserBase;
  adminPrivilege: number[] | undefined;
  resourceAccess: ResourceAccess[] | undefined;
  roleAccess: RoleAccess[] | undefined;
  properties: { [key: string]: string } | undefined;
  resourceTypeAccess: ResourceTypeAccessGeneral[] | undefined;
}

export interface UserProfile {
  userBase: UserBase;
  accessPolicy: AccessPolicyItem[] | undefined;
  adminPrivilege: number[] | undefined;
  resourceType: ResourceType[] | undefined;
  userProperties: { [key: string]: string } | undefined;
  projectProperties: { [key: string]: string } | undefined;
  fromCache: boolean;
}

export interface UserProjectAccess {
  id: number;
  externalId: string | undefined;
  firstName: string | undefined;
  lastName: string | undefined;
  email: string | undefined;
  orgCode: string | undefined;
  isActive: boolean | undefined;
  isApiUser: boolean | undefined;
  projectAccess: ProjectDetail[] | undefined;
  fromCache: boolean;
  isGlobalAdmin: boolean;
}

export interface FilterGroupUi {
  cacheInfo: CacheInfo;
  id: number;
  name: string | undefined;
  sortOrder: number;
  visibility: FilterVisibility;
  filterList: FilterUi[] | undefined;
  icon: string | undefined;
  toolTip: string | undefined;
}

export interface FilterToken {
  label: string | undefined;
  selection: FilterValue[] | undefined;
}

export interface FilterUi {
  cacheInfo: CacheInfo;
  sqlAnalyticResult: SqlAnalyticResult;
  id: number;
  filterGroupId: number;
  filterType: string | undefined;
  values: FilterValueUi[] | undefined;
  token: FilterToken[] | undefined;
  valueRange: FilterValueRange;
  label: string | undefined;
  icon: string | undefined;
  sortOrder: number;
  toolTip: string | undefined;
}

export interface FilterUiSelection {
  id: number;
  filterGroupId: number;
  filterType: string | undefined;
  values: FilterValueUi[] | undefined;
}

export interface FilterValue {
  column: string | undefined;
  value: string | undefined;
  label: string | undefined;
  isDisabled: boolean;
  children: FilterValue[] | undefined;
}

export interface FilterValueRange {
  min: string | undefined;
  max: string | undefined;
  column: string | undefined;
}

export interface FilterValueUi {
  column: string | undefined;
  value: string | undefined;
  isDisabled: boolean;
  children: FilterValueUi[] | undefined;
}

export enum FilterVisibility {
  ShowInHeader = 'ShowInHeader',
  ShowInTabAsIcon = 'ShowInTabAsIcon',
  ShowInTab = 'ShowInTab',
}

export interface AddUserPayload {
  email: string | undefined;
  firstName: string | undefined;
  lastName: string | undefined;
  isApiUser: boolean | undefined;
  externalId: string | undefined;
  redirectUri: string | undefined;
}

export interface AddUserResponse {
  userBase: UserBase;
}

export interface GetUserListResponse {}

export interface GetUserResponse {
  userBase: UserBase;
}

export interface UpdateUserPayload {}

export interface UpdateUserResponse {}

export enum UserSortColumns {
  Id = 'Id',
  ExternalId = 'ExternalId',
  FirstName = 'FirstName',
  LastName = 'LastName',
  Email = 'Email',
}

export interface Country {
  countryNativeName: string;
  countryEnglishName: string;
  countryTag: string;
  countryTagThreeLetter: string;
}

export interface GetCountryListResponse {
  countries: Country[];
}

export interface AddProjectLanguagePayload {
  language: string;
  sortOrder: number;
}

export interface AddProjectPayload {
  name: string;
  description: string | undefined;
  shortName: string;
  isPublic: boolean | undefined;
  projectProperties: AddProjectPropertyPayload[];
  resourceTypes: AddProjectResourceTypePayload[];
  projectLanguages: AddProjectLanguagePayload[];
  providerConnections: AddProjectProviderConnection[];
}

export interface AddProjectPropertyPayload {
  name: string;
  value: string;
}

export interface AddProjectPropertyResponse {
  projectProperty: ProjectProperty;
}

export interface AddProjectProviderConnection {
  providerConnectionId: number;
  resourceTypeId: number;
}

export interface AddProjectResourceTypePayload {
  resourceTypeId: number;
}

export interface AddProjectResponse {
  project: Project2;
}

export interface AddProjectWithConfigurationPayload {
  configurationJson: string;
}

export interface AddProjectWithConfigurationResponse {
  project: Project2;
}

export interface GetProjectListResponse {
  projectList: Project2[];
}

export interface GetProjectPropertyListResponse {
  projectPropertyList: ProjectProperty[];
}

export interface GetProjectPropertyResponse {
  projectProperty: ProjectProperty;
}

export interface GetProjectResponse {
  project: Project2;
}

export interface Project2 {
  id: number;
  name: string;
  description: string | undefined;
  shortName: string;
  isPublic: boolean | undefined;
  projectProperties: ProjectProperty[];
}

export interface ProjectProperty {
  id: number;
  projectId: number;
  name: string;
  value: string;
}

export interface UpdateProjectPayload {
  id: number;
  name: string;
  description: string | undefined;
  shortName: string;
  isPublic: boolean | undefined;
}

export interface UpdateProjectPropertyPayload {
  id: number;
  name: string;
  value: string;
}

export interface UpdateProjectPropertyResponse {
  projectProperty: ProjectProperty;
}

export interface UpdateProjectResponse {
  project: Project2;
}

export interface AddProviderConnectionPayload {
  providerType: string;
  sqlType: string;
  name: string;
  databaseName: string;
  server: string;
  awsSecret: string;
}

export interface AddProviderConnectionResponse {
  providerConnection: ProviderConnection2;
}

export interface GetProviderConnectionListResponse {
  providerConnectionList: ProviderConnection2[];
}

export interface GetProviderConnectionResponse {
  providerConnection: ProviderConnection2;
}

export interface ProviderConnection2 {
  id: number;
  providerType: string;
  sqlType: string;
  name: string;
  databaseName: string;
  server: string;
  awsSecret: string;
}

export interface UpdateProviderConnectionResponse {
  providerConnection: ProviderConnection2;
}

export interface GetResourceTranslationListResponse {
  resourceTranslations: ResourceTranslationResponse[];
}

export interface ResourceTranslationResponse {
  id: number;
  projectId: number;
  resourceId: number;
  translationKey: string;
  language: string;
  translation: string;
  area: string;
  lastUpdatedByUserId: number;
}

export interface AddResourceListFromJsonPayload {
  configurationJson: string;
}

export interface AddResourceListFromJsonResponse {
  resources: { [key: string]: ResourceFull };
}

export interface AddUserResourceAccessListPayload {
  userResourceAccessList: UserResourceAccess[];
}

export interface AddUserResourceAccessListResponse {
  success: boolean;
}

export interface UserResourceAccess {
  userId: number;
  resourceId: number;
  actions: string[];
}

export interface FilterController_CreateFilterUiForResourceResponse {
  cacheInfo: CacheInfo;
  sqlAnalyticResults: SqlAnalyticResults;
  filterGroupList: FilterGroupUi[] | undefined;
}

export interface SetupProjectRequest {
  surveySettings: SurveySettings;
}

export interface SetupProjectResponse {}

export interface SurveySettings {
  surveyType: SurveyType;
  landingPageUrl: string | undefined;
  themeId: number;
  contactEmail: string | undefined;
  pagePersistancy: number;
}

export enum SurveyType {
  OpenAccess = 'OpenAccess',
  AnonymousEmployee = 'AnonymousEmployee',
  InvitationOnly = 'InvitationOnly',
}

export interface PageDefinition {
  search: string | undefined;
  pageSize: number;
  page: number;
}

export interface Page_1OfResourceDTO {
  count: number;
  items: ResourceDTO[] | undefined;
  definition: PageDefinition;
}

export interface Page_1OfResourceFull {
  count: number;
  items: ResourceFull[] | undefined;
  definition: PageDefinition;
}

export interface DeleteGeneralAccessResponse {
  deletedAccessPolicies: number[] | undefined;
}

export interface GeneralAccessFor {
  actionIds: number[] | undefined;
  categoryIds: number[] | undefined;
}

export interface UpdateGeneralAccessResponse {
  deletedAccessPoliciesToRoleIds: number[] | undefined;
  deletedAccessPolicies: number[] | undefined;
  insertedAccessPolicyIds: number[] | undefined;
  insertedAccessPoliciesToRoleIds: number[] | undefined;
}

export interface ResourceAccessFor {
  actionIds: number[] | undefined;
  resourceId: number;
}

export interface AddProjectLanguageRequest {
  language: string | undefined;
  sortOrder: number;
}

export interface AddProjectLanguageResponse {
  cacheInfo: CacheInfo;
}

export interface DeleteProjectLanguageResponse {
  cacheInfo: CacheInfo;
  deletedLanguages: string | undefined;
}

export interface GetAllProjectLanguageResponse {
  cacheInfo: CacheInfo;
  languages: ProjectLanguage[] | undefined;
}

export interface ProjectLanguage {
  id: number;
  language: string | undefined;
  isS3Deployed: number;
  sortOrder: number;
  lastUpdatedByUserId: number;
}

export interface UpdateProjectLanguageRequest {
  language: string | undefined;
  sortOrder: number;
}

export interface UpdateProjectLanguageResponse {}

export interface AddOrUpdateProjectTranslationRequest {
  translations: ProjectTranslation[] | undefined;
}

export interface AddOrUpdateProjectTranslationResponse {
  success: boolean;
}

export interface GetAllProjectTranslationResponse {
  cacheInfo: CacheInfo;
  translations: { [key: string]: string } | undefined;
}

export interface ProjectTranslation {
  key: string | undefined;
  value: string | undefined;
  area: string | undefined;
}

export interface AddOrUpdateResourceTranslationByKeyRequest {
  key: string | undefined;
  translations: ResourceTranslation[] | undefined;
}

export interface AddOrUpdateResourceTranslationRequest {
  key: string | undefined;
  translations: ResourceTranslation[] | undefined;
}

export interface AddOrUpdateResourceTranslationResponse {
  itemsAffected: number;
}

export interface GetAllResourceTranslationResponse {
  cacheInfo: CacheInfo;
  translations: ResourceTranslation[] | undefined;
}

export interface ResourceTranslation {
  value: string | undefined;
  area: string | undefined;
  language: string | undefined;
}

export interface AddOrUpdateTranslationItem {
  resourceId: number;
  area: string | undefined;
  translationKey: string | undefined;
  translation: string | undefined;
  language: string | undefined;
}

export interface AddOrUpdateTranslationResponse {
  itemsAffected: number;
}

export interface AddOrUpdateTranslationsRequest {
  translations: AddOrUpdateTranslationItem[] | undefined;
}

export interface DeleteAllLanguagesTranslationItem {
  area: string | undefined;
  translationKey: string | undefined;
  resourceId: number;
}

export interface DeleteAllLanguagesTranslationsRequest {
  translations: DeleteAllLanguagesTranslationItem[] | undefined;
}

export interface DeleteTranslationsResponse {
  affectedItems: number;
}

export interface ExportTranslationsRequest {
  sourceLanguage: string | undefined;
  targetLanguage: string | undefined;
  fileType: string | undefined;
}

export interface GetJoinedTranslationsResponse {
  joinedTranslations: JoinedTranslation[] | undefined;
}

export interface ImportTranslationsResponse {
  affectedLanguages: string[] | undefined;
}

export interface JoinedTranslation {
  sourceLanguage: string | undefined;
  targetLanguage: string | undefined;
  resourceId: number;
  area: string | undefined;
  translationKey: string | undefined;
  sourceTranslation: string | undefined;
  targetTranslation: string | undefined;
}

export interface Exception {
  targetSite: MethodBase;
  readonly message: string;
  readonly data: { [key: string]: any };
  innerException: Exception;
  helpLink: string | undefined;
  source: string | undefined;
  hResult: number;
  readonly stackTrace: string | undefined;
}

export interface IntPtr {}

export interface ModuleHandle {
  readonly mdStreamVersion: number;
}

export interface Assembly {
  readonly definedTypes: TypeInfo[];
  readonly exportedTypes: Type[];
  readonly codeBase: string | undefined;
  entryPoint: MethodInfo;
  readonly fullName: string | undefined;
  readonly imageRuntimeVersion: string;
  readonly isDynamic: boolean;
  readonly location: string;
  readonly reflectionOnly: boolean;
  readonly isCollectible: boolean;
  readonly isFullyTrusted: boolean;
  readonly customAttributes: CustomAttributeData[];
  readonly escapedCodeBase: string;
  manifestModule: Module;
  readonly modules: Module[];
  readonly globalAssemblyCache: boolean;
  readonly hostContext: number;
  securityRuleSet: SecurityRuleSet;
}

export enum CallingConventions {
  Standard = 'Standard',
  VarArgs = 'VarArgs',
  Any = 'Any',
  HasThis = 'HasThis',
  ExplicitThis = 'ExplicitThis',
}

export interface ConstructorInfo {
  readonly name: string;
  declaringType: Type;
  reflectedType: Type;
  module: Module;
  readonly customAttributes: CustomAttributeData[];
  readonly isCollectible: boolean;
  readonly metadataToken: number;
  attributes: MethodAttributes;
  methodImplementationFlags: MethodImplAttributes;
  callingConvention: CallingConventions;
  readonly isAbstract: boolean;
  readonly isConstructor: boolean;
  readonly isFinal: boolean;
  readonly isHideBySig: boolean;
  readonly isSpecialName: boolean;
  readonly isStatic: boolean;
  readonly isVirtual: boolean;
  readonly isAssembly: boolean;
  readonly isFamily: boolean;
  readonly isFamilyAndAssembly: boolean;
  readonly isFamilyOrAssembly: boolean;
  readonly isPrivate: boolean;
  readonly isPublic: boolean;
  readonly isConstructedGenericMethod: boolean;
  readonly isGenericMethod: boolean;
  readonly isGenericMethodDefinition: boolean;
  readonly containsGenericParameters: boolean;
  methodHandle: RuntimeMethodHandle;
  readonly isSecurityCritical: boolean;
  readonly isSecuritySafeCritical: boolean;
  readonly isSecurityTransparent: boolean;
  memberType: MemberTypes;
}

export interface CustomAttributeData {
  attributeType: Type;
  constructor: ConstructorInfo;
  readonly constructorArguments: CustomAttributeTypedArgument[];
  readonly namedArguments: CustomAttributeNamedArgument[];
}

export interface CustomAttributeNamedArgument {
  memberInfo: MemberInfo;
  typedValue: CustomAttributeTypedArgument;
  readonly memberName: string;
  readonly isField: boolean;
}

export interface CustomAttributeTypedArgument {
  argumentType: Type;
  value: any | undefined;
}

export enum EventAttributes {
  None = 'None',
  SpecialName = 'SpecialName',
  RTSpecialName = 'RTSpecialName',
}

export interface EventInfo {
  readonly name: string;
  declaringType: Type;
  reflectedType: Type;
  module: Module;
  readonly customAttributes: CustomAttributeData[];
  readonly isCollectible: boolean;
  readonly metadataToken: number;
  memberType: MemberTypes;
  attributes: EventAttributes;
  readonly isSpecialName: boolean;
  addMethod: MethodInfo;
  removeMethod: MethodInfo;
  raiseMethod: MethodInfo;
  readonly isMulticast: boolean;
  eventHandlerType: Type;
}

export enum FieldAttributes {
  PrivateScope = 'PrivateScope',
  Private = 'Private',
  FamANDAssem = 'FamANDAssem',
  Assembly = 'Assembly',
  Family = 'Family',
  FamORAssem = 'FamORAssem',
  Public = 'Public',
  FieldAccessMask = 'FieldAccessMask',
  Static = 'Static',
  InitOnly = 'InitOnly',
  Literal = 'Literal',
  NotSerialized = 'NotSerialized',
  HasFieldRVA = 'HasFieldRVA',
  SpecialName = 'SpecialName',
  RTSpecialName = 'RTSpecialName',
  HasFieldMarshal = 'HasFieldMarshal',
  PinvokeImpl = 'PinvokeImpl',
  HasDefault = 'HasDefault',
  ReservedMask = 'ReservedMask',
}

export interface FieldInfo {
  readonly name: string;
  declaringType: Type;
  reflectedType: Type;
  module: Module;
  readonly customAttributes: CustomAttributeData[];
  readonly isCollectible: boolean;
  readonly metadataToken: number;
  memberType: MemberTypes;
  attributes: FieldAttributes;
  fieldType: Type;
  readonly isInitOnly: boolean;
  readonly isLiteral: boolean;
  readonly isNotSerialized: boolean;
  readonly isPinvokeImpl: boolean;
  readonly isSpecialName: boolean;
  readonly isStatic: boolean;
  readonly isAssembly: boolean;
  readonly isFamily: boolean;
  readonly isFamilyAndAssembly: boolean;
  readonly isFamilyOrAssembly: boolean;
  readonly isPrivate: boolean;
  readonly isPublic: boolean;
  readonly isSecurityCritical: boolean;
  readonly isSecuritySafeCritical: boolean;
  readonly isSecurityTransparent: boolean;
  fieldHandle: RuntimeFieldHandle;
}

export enum GenericParameterAttributes {
  None = 'None',
  Covariant = 'Covariant',
  Contravariant = 'Contravariant',
  VarianceMask = 'VarianceMask',
  ReferenceTypeConstraint = 'ReferenceTypeConstraint',
  NotNullableValueTypeConstraint = 'NotNullableValueTypeConstraint',
  DefaultConstructorConstraint = 'DefaultConstructorConstraint',
  SpecialConstraintMask = 'SpecialConstraintMask',
}

export interface ICustomAttributeProvider {}

export interface MemberInfo {
  memberType: MemberTypes;
  declaringType: Type;
  reflectedType: Type;
  readonly name: string;
  module: Module;
  readonly customAttributes: CustomAttributeData[];
  readonly isCollectible: boolean;
  readonly metadataToken: number;
}

export enum MemberTypes {
  Constructor = 'Constructor',
  Event = 'Event',
  Field = 'Field',
  Method = 'Method',
  Property = 'Property',
  TypeInfo = 'TypeInfo',
  Custom = 'Custom',
  NestedType = 'NestedType',
  All = 'All',
}

export enum MethodAttributes {
  ReuseSlot = 'ReuseSlot',
  Private = 'Private',
  FamANDAssem = 'FamANDAssem',
  Assembly = 'Assembly',
  Family = 'Family',
  FamORAssem = 'FamORAssem',
  Public = 'Public',
  MemberAccessMask = 'MemberAccessMask',
  UnmanagedExport = 'UnmanagedExport',
  Static = 'Static',
  Final = 'Final',
  Virtual = 'Virtual',
  HideBySig = 'HideBySig',
  NewSlot = 'NewSlot',
  CheckAccessOnOverride = 'CheckAccessOnOverride',
  Abstract = 'Abstract',
  SpecialName = 'SpecialName',
  RTSpecialName = 'RTSpecialName',
  PinvokeImpl = 'PinvokeImpl',
  HasSecurity = 'HasSecurity',
  RequireSecObject = 'RequireSecObject',
  ReservedMask = 'ReservedMask',
}

export interface MethodBase {
  memberType: MemberTypes;
  readonly name: string;
  declaringType: Type;
  reflectedType: Type;
  module: Module;
  readonly customAttributes: CustomAttributeData[];
  readonly isCollectible: boolean;
  readonly metadataToken: number;
  attributes: MethodAttributes;
  methodImplementationFlags: MethodImplAttributes;
  callingConvention: CallingConventions;
  readonly isAbstract: boolean;
  readonly isConstructor: boolean;
  readonly isFinal: boolean;
  readonly isHideBySig: boolean;
  readonly isSpecialName: boolean;
  readonly isStatic: boolean;
  readonly isVirtual: boolean;
  readonly isAssembly: boolean;
  readonly isFamily: boolean;
  readonly isFamilyAndAssembly: boolean;
  readonly isFamilyOrAssembly: boolean;
  readonly isPrivate: boolean;
  readonly isPublic: boolean;
  readonly isConstructedGenericMethod: boolean;
  readonly isGenericMethod: boolean;
  readonly isGenericMethodDefinition: boolean;
  readonly containsGenericParameters: boolean;
  methodHandle: RuntimeMethodHandle;
  readonly isSecurityCritical: boolean;
  readonly isSecuritySafeCritical: boolean;
  readonly isSecurityTransparent: boolean;
}

export enum MethodImplAttributes {
  IL = 'IL',
  Native = 'Native',
  OPTIL = 'OPTIL',
  Runtime = 'Runtime',
  Unmanaged = 'Unmanaged',
  NoInlining = 'NoInlining',
  ForwardRef = 'ForwardRef',
  Synchronized = 'Synchronized',
  NoOptimization = 'NoOptimization',
  PreserveSig = 'PreserveSig',
  AggressiveInlining = 'AggressiveInlining',
  AggressiveOptimization = 'AggressiveOptimization',
  InternalCall = 'InternalCall',
  MaxMethodImplVal = 'MaxMethodImplVal',
}

export interface MethodInfo {
  readonly name: string;
  declaringType: Type;
  reflectedType: Type;
  module: Module;
  readonly customAttributes: CustomAttributeData[];
  readonly isCollectible: boolean;
  readonly metadataToken: number;
  attributes: MethodAttributes;
  methodImplementationFlags: MethodImplAttributes;
  callingConvention: CallingConventions;
  readonly isAbstract: boolean;
  readonly isConstructor: boolean;
  readonly isFinal: boolean;
  readonly isHideBySig: boolean;
  readonly isSpecialName: boolean;
  readonly isStatic: boolean;
  readonly isVirtual: boolean;
  readonly isAssembly: boolean;
  readonly isFamily: boolean;
  readonly isFamilyAndAssembly: boolean;
  readonly isFamilyOrAssembly: boolean;
  readonly isPrivate: boolean;
  readonly isPublic: boolean;
  readonly isConstructedGenericMethod: boolean;
  readonly isGenericMethod: boolean;
  readonly isGenericMethodDefinition: boolean;
  readonly containsGenericParameters: boolean;
  methodHandle: RuntimeMethodHandle;
  readonly isSecurityCritical: boolean;
  readonly isSecuritySafeCritical: boolean;
  readonly isSecurityTransparent: boolean;
  memberType: MemberTypes;
  returnParameter: ParameterInfo;
  returnType: Type;
  returnTypeCustomAttributes: ICustomAttributeProvider;
}

export interface Module {
  assembly: Assembly;
  readonly fullyQualifiedName: string;
  readonly name: string;
  readonly mdStreamVersion: number;
  readonly moduleVersionId: string;
  readonly scopeName: string;
  moduleHandle: ModuleHandle;
  readonly customAttributes: CustomAttributeData[];
  readonly metadataToken: number;
}

export enum ParameterAttributes {
  None = 'None',
  In = 'In',
  Out = 'Out',
  Lcid = 'Lcid',
  Retval = 'Retval',
  Optional = 'Optional',
  HasDefault = 'HasDefault',
  HasFieldMarshal = 'HasFieldMarshal',
  Reserved3 = 'Reserved3',
  Reserved4 = 'Reserved4',
  ReservedMask = 'ReservedMask',
}

export interface ParameterInfo {
  attributes: ParameterAttributes;
  member: MemberInfo;
  readonly name: string | undefined;
  parameterType: Type;
  readonly position: number;
  readonly isIn: boolean;
  readonly isLcid: boolean;
  readonly isOptional: boolean;
  readonly isOut: boolean;
  readonly isRetval: boolean;
  readonly defaultValue: any | undefined;
  readonly rawDefaultValue: any | undefined;
  readonly hasDefaultValue: boolean;
  readonly customAttributes: CustomAttributeData[];
  readonly metadataToken: number;
}

export enum PropertyAttributes {
  None = 'None',
  SpecialName = 'SpecialName',
  RTSpecialName = 'RTSpecialName',
  HasDefault = 'HasDefault',
  Reserved2 = 'Reserved2',
  Reserved3 = 'Reserved3',
  Reserved4 = 'Reserved4',
  ReservedMask = 'ReservedMask',
}

export interface PropertyInfo {
  readonly name: string;
  declaringType: Type;
  reflectedType: Type;
  module: Module;
  readonly customAttributes: CustomAttributeData[];
  readonly isCollectible: boolean;
  readonly metadataToken: number;
  memberType: MemberTypes;
  propertyType: Type;
  attributes: PropertyAttributes;
  readonly isSpecialName: boolean;
  readonly canRead: boolean;
  readonly canWrite: boolean;
  getMethod: MethodInfo;
  setMethod: MethodInfo;
}

export enum TypeAttributes {
  NotPublic = 'NotPublic',
  Public = 'Public',
  NestedPublic = 'NestedPublic',
  NestedPrivate = 'NestedPrivate',
  NestedFamily = 'NestedFamily',
  NestedAssembly = 'NestedAssembly',
  NestedFamANDAssem = 'NestedFamANDAssem',
  NestedFamORAssem = 'NestedFamORAssem',
  SequentialLayout = 'SequentialLayout',
  ExplicitLayout = 'ExplicitLayout',
  LayoutMask = 'LayoutMask',
  Interface = 'Interface',
  Abstract = 'Abstract',
  Sealed = 'Sealed',
  SpecialName = 'SpecialName',
  RTSpecialName = 'RTSpecialName',
  Import = 'Import',
  Serializable = 'Serializable',
  WindowsRuntime = 'WindowsRuntime',
  UnicodeClass = 'UnicodeClass',
  AutoClass = 'AutoClass',
  CustomFormatClass = 'CustomFormatClass',
  HasSecurity = 'HasSecurity',
  ReservedMask = 'ReservedMask',
  BeforeFieldInit = 'BeforeFieldInit',
  CustomFormatMask = 'CustomFormatMask',
}

export interface TypeInfo {
  readonly name: string;
  readonly customAttributes: CustomAttributeData[];
  readonly isCollectible: boolean;
  readonly metadataToken: number;
  readonly isInterface: boolean;
  memberType: MemberTypes;
  readonly namespace: string | undefined;
  readonly assemblyQualifiedName: string | undefined;
  readonly fullName: string | undefined;
  assembly: Assembly;
  module: Module;
  readonly isNested: boolean;
  declaringType: Type;
  declaringMethod: MethodBase;
  reflectedType: Type;
  underlyingSystemType: Type;
  readonly isTypeDefinition: boolean;
  readonly isArray: boolean;
  readonly isByRef: boolean;
  readonly isPointer: boolean;
  readonly isConstructedGenericType: boolean;
  readonly isGenericParameter: boolean;
  readonly isGenericTypeParameter: boolean;
  readonly isGenericMethodParameter: boolean;
  readonly isGenericType: boolean;
  readonly isGenericTypeDefinition: boolean;
  readonly isSZArray: boolean;
  readonly isVariableBoundArray: boolean;
  readonly isByRefLike: boolean;
  readonly hasElementType: boolean;
  readonly genericTypeArguments: Type[];
  readonly genericParameterPosition: number;
  genericParameterAttributes: GenericParameterAttributes;
  attributes: TypeAttributes;
  readonly isAbstract: boolean;
  readonly isImport: boolean;
  readonly isSealed: boolean;
  readonly isSpecialName: boolean;
  readonly isClass: boolean;
  readonly isNestedAssembly: boolean;
  readonly isNestedFamANDAssem: boolean;
  readonly isNestedFamily: boolean;
  readonly isNestedFamORAssem: boolean;
  readonly isNestedPrivate: boolean;
  readonly isNestedPublic: boolean;
  readonly isNotPublic: boolean;
  readonly isPublic: boolean;
  readonly isAutoLayout: boolean;
  readonly isExplicitLayout: boolean;
  readonly isLayoutSequential: boolean;
  readonly isAnsiClass: boolean;
  readonly isAutoClass: boolean;
  readonly isUnicodeClass: boolean;
  readonly isCOMObject: boolean;
  readonly isContextful: boolean;
  readonly isEnum: boolean;
  readonly isMarshalByRef: boolean;
  readonly isPrimitive: boolean;
  readonly isValueType: boolean;
  readonly isSignatureType: boolean;
  readonly isSecurityCritical: boolean;
  readonly isSecuritySafeCritical: boolean;
  readonly isSecurityTransparent: boolean;
  structLayoutAttribute: StructLayoutAttribute;
  typeInitializer: ConstructorInfo;
  typeHandle: RuntimeTypeHandle;
  readonly guid: string;
  baseType: Type;
  readonly isSerializable: boolean;
  readonly containsGenericParameters: boolean;
  readonly isVisible: boolean;
  readonly genericTypeParameters: Type[];
  readonly declaredConstructors: ConstructorInfo[];
  readonly declaredEvents: EventInfo[];
  readonly declaredFields: FieldInfo[];
  readonly declaredMembers: MemberInfo[];
  readonly declaredMethods: MethodInfo[];
  readonly declaredNestedTypes: TypeInfo[];
  readonly declaredProperties: PropertyInfo[];
  readonly implementedInterfaces: Type[];
}

export enum LayoutKind {
  Sequential = 'Sequential',
  Explicit = 'Explicit',
  Auto = 'Auto',
}

export interface StructLayoutAttribute {
  readonly typeId: any;
  value: LayoutKind;
}

export interface RuntimeFieldHandle {
  value: IntPtr;
}

export interface RuntimeMethodHandle {
  value: IntPtr;
}

export interface RuntimeTypeHandle {
  value: IntPtr;
}

export enum SecurityRuleSet {
  None = 'None',
  Level1 = 'Level1',
  Level2 = 'Level2',
}

export interface Type {
  readonly name: string;
  readonly customAttributes: CustomAttributeData[];
  readonly isCollectible: boolean;
  readonly metadataToken: number;
  readonly isInterface: boolean;
  memberType: MemberTypes;
  readonly namespace: string | undefined;
  readonly assemblyQualifiedName: string | undefined;
  readonly fullName: string | undefined;
  assembly: Assembly;
  module: Module;
  readonly isNested: boolean;
  declaringType: Type;
  declaringMethod: MethodBase;
  reflectedType: Type;
  underlyingSystemType: Type;
  readonly isTypeDefinition: boolean;
  readonly isArray: boolean;
  readonly isByRef: boolean;
  readonly isPointer: boolean;
  readonly isConstructedGenericType: boolean;
  readonly isGenericParameter: boolean;
  readonly isGenericTypeParameter: boolean;
  readonly isGenericMethodParameter: boolean;
  readonly isGenericType: boolean;
  readonly isGenericTypeDefinition: boolean;
  readonly isSZArray: boolean;
  readonly isVariableBoundArray: boolean;
  readonly isByRefLike: boolean;
  readonly hasElementType: boolean;
  readonly genericTypeArguments: Type[];
  readonly genericParameterPosition: number;
  genericParameterAttributes: GenericParameterAttributes;
  attributes: TypeAttributes;
  readonly isAbstract: boolean;
  readonly isImport: boolean;
  readonly isSealed: boolean;
  readonly isSpecialName: boolean;
  readonly isClass: boolean;
  readonly isNestedAssembly: boolean;
  readonly isNestedFamANDAssem: boolean;
  readonly isNestedFamily: boolean;
  readonly isNestedFamORAssem: boolean;
  readonly isNestedPrivate: boolean;
  readonly isNestedPublic: boolean;
  readonly isNotPublic: boolean;
  readonly isPublic: boolean;
  readonly isAutoLayout: boolean;
  readonly isExplicitLayout: boolean;
  readonly isLayoutSequential: boolean;
  readonly isAnsiClass: boolean;
  readonly isAutoClass: boolean;
  readonly isUnicodeClass: boolean;
  readonly isCOMObject: boolean;
  readonly isContextful: boolean;
  readonly isEnum: boolean;
  readonly isMarshalByRef: boolean;
  readonly isPrimitive: boolean;
  readonly isValueType: boolean;
  readonly isSignatureType: boolean;
  readonly isSecurityCritical: boolean;
  readonly isSecuritySafeCritical: boolean;
  readonly isSecurityTransparent: boolean;
  structLayoutAttribute: StructLayoutAttribute;
  typeInitializer: ConstructorInfo;
  typeHandle: RuntimeTypeHandle;
  readonly guid: string;
  baseType: Type;
  readonly isSerializable: boolean;
  readonly containsGenericParameters: boolean;
  readonly isVisible: boolean;
}

export class SwaggerException extends Error {
  override message: string;
  status: number;
  response: string;
  headers: { [key: string]: any };
  result: any;

  constructor(message: string, status: number, response: string, headers: { [key: string]: any }, result: any) {
    super();

    this.message = message;
    this.status = status;
    this.response = response;
    this.headers = headers;
    this.result = result;
  }

  protected isSwaggerException = true;

  static isSwaggerException(obj: any): obj is SwaggerException {
    return obj.isSwaggerException === true;
  }
}

function throwException(
  message: string,
  status: number,
  response: string,
  headers: { [key: string]: any },
  result?: any
): Observable<any> {
  if (result !== null && result !== undefined) return _observableThrow(result);
  else return _observableThrow(new SwaggerException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
  return new Observable<string>((observer: any) => {
    if (!blob) {
      observer.next('');
      observer.complete();
    } else {
      let reader = new FileReader();
      reader.onload = (event) => {
        observer.next((event.target as any).result);
        observer.complete();
      };
      reader.readAsText(blob);
    }
  });
}
